import BaseComponent from '@/components/base';
import { defineComponent } from '@/components/base';
import { ButtonStyles } from '@/components/style';
import ShopifyAPI from '@/gateway/ShopifyAPI';
import { style } from '@/components/mini-quiz/style';
import { fragranceMap } from '@/utils/fragrance-map';
import { fireGTMEvent } from '@/utils';
import { v4 } from 'uuid';
import FlashMessageUtil from '@/utils/flash-message-util';
import CartHandler from '@/components/mini-quiz/mini-quiz-basic/cartHandler';
import { getParametersFromContext } from '@/components/mini-quiz/mini-quiz-basic/cartHandler';
import { RenderQuizQuestion } from '@/components/mini-quiz/mini-quiz-basic/layout';
import QuantityInputBasic from '@/components/quantity-input-basic';
import Events from '@/components/mini-quiz/mini-quiz-basic/events';
import QuizContext from '@/components/mini-quiz/quiz-context';
import axios from 'axios';

const DEFAULT_FRAGRANCE = 'coco';
const LOADING_CTA_TEXT = 'loading...';
const DEFAULT_CTA_TEXT = 'add to cart';
const ADDED_TO_CART_CTA_TEXT = 'added to cart';
const PDP_FROM_RECOMMENDATION_EVENT = 'dl_ga4_pdp_from_recommendation';
const ADD_TO_CART_FROM_RECOMMENDATION_EVENT =
  'dl_ga4_add_to_cart_from_recommendation';

const ACTIONS = {
  STAY_ON_PDP: 'stay_on_pdp',
  REDIRECT_TO_CHECKOUT: 'redirect_to_checkout'
};

export default class MiniQuizBasic extends BaseComponent {
  static quizTypeProperties = {
    standard: {
      colorOptions: 'variants'
    },
    bundle: {
      colorOptions: 'metafieldColors'
    }
  };

  onConstruct() {
    defineComponent('quantity-input-basic', QuantityInputBasic);

    this.circleOptions =
      MiniQuizBasic.quizTypeProperties[this.quizType].colorOptions;
    this.quizContext = document.querySelector('quiz-context');

    const container = document.querySelector(
      '.product-core-inner.product-core-inner--main'
    );
    container && (container.style.overflowY = 'auto');

    this.name = '';
    this.quantity = 1;
  }

  render() {
    const dataKeys = [...Object.keys(this.data)];
    const circleOptions = dataKeys.filter((x) =>
      this.circleOptions?.includes(x)
    );
    const metafieldSiliconeFree = this.data.metafieldSiliconeFree?.value;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    console.log('isMobile =>', isMobile);
    const quizLayout = this.data.metafieldLayout?.value ?? {};
    const orderLayout = Array.isArray(this.data.metafieldLayout?.value)
      ? this.data.metafieldLayout?.value?.map((item) => {
          return item.property;
        })
      : [];

    const quizPageUrl = this.getQuizUrl();

    this.fixDataLayout();

    dataKeys?.sort((a, b) => {
      const indexA = orderLayout.indexOf(a);
      const indexB = orderLayout.indexOf(b);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    const lastDropDown = [orderLayout?.pop()];
    return `
      ${ButtonStyles}
      ${style}

      ${
        this.showCustomizations
          ? `
        <div class="customizations-container">
          <h2 style="margin-bottom: 0px;">Customize to You</h2>
          <a
              href="${quizPageUrl}"
              style="font-size: 14px; color: #8F9494;"
              >
              Not sure what you need? Take our quiz.
          </a>

          ${
            this.showProfileName
              ? `
            <h3>customize Name</h3>
            <div>
                <label>function of:</label>
                <input class ="input-name" id="nameInput" type="text" placeholder="Name" maxlength="10" autocomplete="off"/>
            </div>
            <span class="error-name-message">Oops! You didn't input your name.</span>
          `
              : ''
          }

          ${circleOptions
            .filter((key) => this.data[key]?.value?.length > 0)
            .map((key) => {
              const ops = this.data[key].value.map((val) => {
                return val.color;
              });
              const colorOptionsAsJsonString = JSON.stringify(ops);

              const colorOptions = this.data[key].value.map((val) => {
                return val.hex;
              });
              const colorOptionsJsonFormatted = JSON.stringify(colorOptions);

              if (ops.length === 1) return '';

              return RenderQuizQuestion({
                ...this.data[key],
                colorOptionsJsonFormatted,
                productHandle: this.productHandle,
                excludedColors: this.excludedColors,
                excludedProductColorsVariantsFromMiniQuiz:
                  this.excludedProductColorsVariantsFromMiniQuiz,
                colorOptions: colorOptionsAsJsonString,
                inputType: 'circle',
                quizType: this.quizType
              });
            })}

          ${dataKeys
            .filter((x) => orderLayout.includes(x))
            .map((key) => {
              const optionData = {
                ...this.data[key],
                inputType: quizLayout.find((x) => x.property === key).inputType,
                ...(key === 'fragrances' && { value: this.fragrances })
              };

              return RenderQuizQuestion(optionData);
            })
            .join('')}

             ${dataKeys
               .filter((x) => lastDropDown.includes(x))
               .map((key) => {
                 const optionData = {
                   ...this.data[key],
                   inputType: quizLayout.find((x) => x.property === key)
                     .inputType,
                   ...(key === 'fragrances' && { value: this.fragrances })
                 };

                 return RenderQuizQuestion(optionData);
               })
               .join('')}
               ${
                 this.bundleIsRetail
                   ? ''
                   : `
               <h3 id="ModalButtonIngredientsList" style="cursor: pointer; text-decoration: underline;"> Ingredients List</h3>
               `
               }
        </div>`
          : ''
      }
      <plan-selector>
        <data name="products" type="json">
            ${JSON.stringify(this.data.products.value || [])}
        </data>
      </plan-selector>

      ${
        this.showQuantityInput
          ? `<div class="quantity-wrapper">
              <span>Quantity</span>
              <quantity-input-basic
              quantity="1"
              handle="${this.productHandle}"
            ></quantity-input-basic>
            </div>`
          : ''
      }

      <button
          id="addToCartButton"
          class="cta-1 add-all addRegimenToCart"
          style="width: 100%;    bottom: 1%; position: sticky;z-index: 2;"
          type="submit"
          name="add"
          ${!this.forceAddToCart ? 'disabled' : ''}
      >
          <span class="add-to-cart-text"></span>
      </button>

    <modal-component enabled="${this.enabled}" modal-width="${
      !isMobile ? '600px' : '366px'
    }" >
        <div style="margin-top: -45px;">
          <h2 style="font-size:28px; font-weight: 400">About Silicones</h2>
          <p>Silicones are synthetic ingredients known for improving smoothness, shine and ease of detangling. However, some find silicone can weigh down their hair. Our silicone is a lightweight formulation that will work for most. In haircare, silicones are used to create slip, help smooth and protect from heat.</p>
        </div>
    </modal-component>

    <modal-component enabled="${this.enabled}" modal-width="${
      !isMobile ? '600px' : '366px'
    }" modal-height="${!isMobile ? 'auto' : '300px'}" id="ingredientsListModal">
       <div style="overflow-y:auto; ${
         !isMobile ? 'max-height:500px; ' : 'max-height:300px;'
       }">
         <h2 style="font-size:28px; font-weight: 400">Ingredients List</h2>
         <div id="ingredientsList">
         </div>
       </div>
   </modal-component>


    `;
  }

  getQuizUrl() {
    const productType = this.data.products?.value?.[0]?.productType;
    const quizPageUrlMap = {
      Haircare: 'hair-quiz',
      Bodycare: 'body-quiz',
      Skincare: 'skin-quiz'
    };
    const quizPageUrl = `/pages/${
      quizPageUrlMap[productType] ?? quizPageUrlMap.Haircare
    }`;
    return quizPageUrl;
  }

  fixDataLayout() {
    Object.keys(this.data).forEach((item) => {
      const layoutItem = Array.isArray(this.data.metafieldLayout?.value)
        ? this.data.metafieldLayout?.value?.find(
            (layout) => layout.property === item
          )
        : [];
      if (layoutItem?.inputType === 'button') {
        if (item !== 'hairGoals') {
          this.data[item].value.forEach((value) => {
            value.dataKey = value.value;
            value.image = value.imgUrl;
            value.name = value.text;
            value.layout = layoutItem.inputType;
            value.quantityToSelect = layoutItem.quantityToSelect;
          });
        } else {
          this.data[item].value.forEach((value) => {
            value.layout = layoutItem.inputType;
            value.quantityToSelect = layoutItem.quantityToSelect;
          });
        }
      }
    });
  }

  afterAddToCartHandler() {
    if (this.fromRecommendation) {
      fireGTMEvent(ADD_TO_CART_FROM_RECOMMENDATION_EVENT, {
        product_handle: this.productHandle
      });
    }
    if (this.afterAddToCartAction === ACTIONS.STAY_ON_PDP) {
      this.updateCtaText();
      this.setCtaStateTimeout();
      this.dispatchEvent(
        new CustomEvent(QuizContext.Events.AddedToCart, {
          bubbles: true,
          composed: true
        })
      );
    } else {
      window.location.href = `${window.Shopify.routes.root}${this.ctaUrl}`;
    }
  }

  addToCart(productToAdd) {
    this.buttonComponent.setAttribute('disabled', 'true');
    ShopifyAPI.addToCart({
      items: productToAdd
    })
      .then((response) => {
        if (!response.ok || response.error) {
          this.setCtaToDefault();
          this.buttonComponent.removeAttribute('disabled');
          FlashMessageUtil.showFlashMessage({
            message: "We couldn't add this to your cart. Please try again.",
            error: true
          });
        } else {
          this.afterAddToCartHandler();
        }
      })
      .catch((err) => {
        console.error(err);
        this.buttonComponent.removeAttribute('disabled');
      });
  }

  afterMount() {
    this.buttonComponent?.addEventListener('click', () => {
      const regimenObject = this.forceAddToCart ? {} : this.getRegimenObject();
      CartHandler[this.quizType](regimenObject, this);
    });

    if (this.fromRecommendation) {
      fireGTMEvent(PDP_FROM_RECOMMENDATION_EVENT, {
        product_handle: this.productHandle
      });
    }

    this.setCtaToDefault();

    if (this.showQuantityInput) {
      const quantityInputComponent = this.shadowRoot.querySelector(
        'quantity-input-basic'
      );
      quantityInputComponent.onChangeHandler = this.setQuantity;
    }

    this.shadowRoot
      .getElementById('nameInput')
      .addEventListener('input', function () {
        if (this.value.length > 10) {
          this.value = this.value.slice(0, 10);
        }
      });

    this.colorSelector.onSelected = (color) => {
      const imageSelected = this.data.variants?.value?.find(
        (x) => x.color === color
      )?.image;
      if (this.quizType == 'standard') {
        this.quizContext.changeMainImage(
          imageSelected ?? this.data.variants?.value[0]?.image
        );
      }
    };

    const dropdownElements =
      this.shadowRoot.querySelectorAll('[id$="Selector"]');
    const buttonElements = this.shadowRoot.querySelectorAll('[id$="Buttons"]');

    dropdownElements.forEach((component) => {
      component?.addEventListener('selectedDropDown', () =>
        this.handleChildEvent()
      );
    });

    buttonElements.forEach((component) => {
      component?.addEventListener('buttonsChange', () =>
        this.handleChildEvent()
      );
    });

    this.hairGoalsComponent?.addEventListener('buttonsChange', (ev) =>
      this.handleChildEvent()
    );

    const notSureSilicone = this.shadowRoot.querySelector('#ModalButton');
    const ingredientsList = this.shadowRoot.querySelector(
      '#ModalButtonIngredientsList'
    );
    const modalComponent = this.shadowRoot.querySelector('modal-component');
    const ingredientsListModal = this.shadowRoot.querySelector(
      '#ingredientsListModal'
    );
    notSureSilicone?.addEventListener('click', () => {
      modalComponent.enabled = true;
    });
    ingredientsList?.addEventListener('click', async () => {
      ingredientsListModal.enabled = true;
      this.loadingIngredients = true;
      const payloadObject = this.getPayloadObject();
      const url = process.env.INGREDIENTS_LIST_API;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'X-ICAT-TOKEN': process.env.X_ICAT_TOKEN,
          'X-requested-With': 'csrftokenization'
        }
      };
      const ingredientsListContent =
        ingredientsListModal.querySelector('#ingredientsList');
      const regimenObject = this.getRegimenObject();

      if (!regimenObject.__hair_goals && this.productType === 'hair') {
        ingredientsListContent.innerHTML =
          'Oops! We couldn’t load the ingredients. Please choose a hair goal first.';
        return;
      }

      if (!regimenObject.__body_moisture && this.productType === 'body') {
        ingredientsListContent.innerHTML =
          'Oops! We couldn’t load the ingredients. Please choose a body moisture.';
        return;
      }

      // Update the modal content directly
      if (ingredientsListContent) {
        ingredientsListContent.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0688/9960/2752/files/loader.gif?v=1713963298">`;
      }

      try {
        const response = await axios.post(url, payloadObject, config);
        this.showIngredientList(response.data, ingredientsListContent);
      } catch (e) {
        ingredientsListContent.innerHTML =
          'Error on get ingredients list, please, try again later.';
      }
    });

    this.nameComponent?.addEventListener('input', (ev) => {
      this.name = ev.target.value ? ev.target.value : '';
      this.handleChildEvent();
    });

    this.insertShopPayTerms();
  }

  insertShopPayTerms() {
    const shopPayPaymentTermsContainer = document.querySelector(
      '#shop-pay-payment-terms-container'
    );
    if (!shopPayPaymentTermsContainer) return;
    const shopPayShopifyPaymentTerms =
      shopPayPaymentTermsContainer.querySelector('shopify-payment-terms');
    shopPayPaymentTermsContainer.remove();
    this.shadowRoot.insertBefore(
      shopPayShopifyPaymentTerms,
      this.buttonComponent
    );

    const intervalId = setInterval(() => {
      const boldElement =
        shopPayShopifyPaymentTerms.shadowRoot.querySelector('p .font-bold');

      if (boldElement) {
        const products = this.data.products.value;

        let totalSubscriptionPrice = 0;

        if (products.length > 0) {
          products.map((element) => {
            return (totalSubscriptionPrice += element.variants[0].price);
          });
        }

        const discountVal = this.data.discountSubscriptionMetafield.value;

        let newTotalSubscriptionPrice = 0;
        if (discountVal) {
          const percentValue = Number(discountVal);
          const discountValue = totalSubscriptionPrice * (percentValue / 100);
          newTotalSubscriptionPrice = totalSubscriptionPrice - discountValue;
        } else {
          newTotalSubscriptionPrice = totalSubscriptionPrice;
        }

        boldElement.innerHTML = `${window.Shopify.formatMoney(
          newTotalSubscriptionPrice,
          window.theme.moneyFormat
        )}`;

        clearInterval(intervalId);
      }
    }, 1000);
  }

  updateCtaText() {
    const newText =
      this.ctaText == DEFAULT_CTA_TEXT
        ? LOADING_CTA_TEXT
        : this.ctaText == LOADING_CTA_TEXT
          ? ADDED_TO_CART_CTA_TEXT
          : DEFAULT_CTA_TEXT;
    this.ctaText = newText;
  }

  setCtaStateTimeout() {
    if (this.ctaTimeout) {
      clearTimeout(this.ctaTimeout);
    }
    this.ctaTimeout = setTimeout(() => {
      this.updateCtaText();
      this.handleChildEvent();
    }, 3000);
  }

  renderComponentLayout(key) {
    const dataKey = this.data[key];
    if (dataKey?.value?.length > 0) {
      const isButton = dataKey.value.some((item) => item.layout === 'button');
      if (isButton) {
        return this.renderButtonComponent(key);
      } else {
        return this.mapDropdown(key);
      }
    }
  }

  renderButtonComponent(key) {
    const dataKey = this.data[key];
    const KeyNameMap = {
      hairTypes: 'Hair Type',
      hairThickness: 'Hair Thickness',
      scalpType: 'Scalp Moisture',
      stylingGoals: 'Styling Goals',
      hairGoals: 'Hair Goals',
      holdStrength: 'Hold Strength'
    };
    const keyName = KeyNameMap[key] ?? key;
    const quantityToSelect = dataKey?.value[0]?.quantityToSelect || 1;
    const objectConfig = {
      keyName,
      quantityToSelect
    };

    return `
    <buttons-layout id="${key}SelectorButtons">
      <data name="options" type="json">
        ${JSON.stringify(dataKey?.value || [])}
      </data>
      <data name="config" type="json">
        ${JSON.stringify(objectConfig)}
      </data>
    </buttons-layout>
    `;
  }

  mapDropdown(key) {
    const KeyNameMap = {
      hairTypes: 'Hair Type',
      hairThickness: 'hair Thickness',
      scalpType: 'scalp Moisture',
      stylingGoals: 'styling Goals',
      holdStrength: 'Hold Strength'
    };
    const dataKey = this.data[key];
    const keyName = KeyNameMap[key] ?? key;
    if (dataKey?.value?.length > 0) {
      if (key === 'fragrances') {
        const fragrancesJsonToSend = this.fragrances;
        return `
        <h3>${keyName}</h3>
        <dropdown-component id="${key}Selector">
          <data name="options" type="json">
            ${JSON.stringify(fragrancesJsonToSend)}
          </data>
        </dropdown-component>`;
      }
      return `
      <h3>${keyName}</h3>
      <dropdown-component id="${key}Selector">
        <data name="options" type="json">
          ${JSON.stringify(dataKey.value)}
        </data>
      </dropdown-component>`;
    }
  }

  showIngredientList(data, ingredientsListContent) {
    ingredientsListContent.innerHTML = `
     ${Object.entries(data.ingredients)
       .map(
         ([key, ingredients]) => `
      <div class="ingredients-list-item">
        <h4>${key}</h4>
        <p>${ingredients}</p>
      </div>
     `
       )
       .join('')}
    `;
  }

  getPayloadObject() {
    const regimenObject = this.getRegimenObject();
    const quizType = this.quizType;
    const initialObjectHair = {
      fragrance: regimenObject.__fragrance,
      fragrance_strength: regimenObject.__fragrance_strength,
      profile_type: regimenObject.__profile_type,
      silicone_free: String(regimenObject.__silicone_free),
      damage_level: String(regimenObject.__damage_level),
      hair_type: regimenObject.__hair_type,
      hair_structure: regimenObject.__hair_structure,
      scalp_moisture: regimenObject.__scalp_moisture,
      hair_goals: regimenObject.__hair_goals
    };
    const initialObjectBody = {
      fragrance: regimenObject.__fragrance,
      body_moisture: regimenObject.__body_moisture,
      fragrance_strength: regimenObject.__fragrance_strength,
      profile_type: regimenObject.__profile_type,
      silicone_free: String(regimenObject.__silicone_free)
    };
    const colorSelected =
      this.shadowRoot.querySelector('color-selection')?.selectedColor;
    const productType = this.productType;
    if (quizType !== 'bundle') {
      const productID = Number(this.data.products.value[0].id);
      const variantID = Number(this.variantId);
      const productHandle = this.productHandle;
      const colorVariantProduct = this.data.products.value[0].variants.find(
        (variant) => variant.title.includes(colorSelected)
      );
      if (productType === 'hair') {
        const payloadObject = {
          ...initialObjectHair,
          variant_id: colorVariantProduct?.id ?? variantID,
          product_id: productID,
          product_handle: productHandle
        };
        return {
          requests: [payloadObject]
        };
      }
      if (productType === 'body') {
        const payloadObject = {
          ...initialObjectBody,
          variant_id: colorVariantProduct?.id ?? variantID,
          product_id: productID,
          product_handle: productHandle
        };
        return {
          requests: [payloadObject]
        };
      }
    }
    if (quizType === 'bundle') {
      const productsArray = this.data.products.value;
      const arrayPayload = productsArray.reduce((acc, product) => {
        const productID = Number(product.id);
        const productHandle = product.handle;

        let variantId;
        if (product.variants.length > 1) {
          const colorVariantProduct = product.variants.find((variant) =>
            variant.title.includes(colorSelected)
          );
          variantId = colorVariantProduct
            ? colorVariantProduct.id
            : product.variants[0].id;
        } else {
          variantId = product.variants[0].id;
        }

        const payloadObject = {
          ...initialObjectHair,
          variant_id: variantId,
          product_id: productID,
          product_handle: productHandle
        };

        acc.push(payloadObject);
        return acc;
      }, []);

      return {
        requests: arrayPayload
      };
    }
  }
  getRegimenObject() {
    const hairGoals = this.hairGoals.join(',');
    const stylingGoals =
      typeof this.stylingGoals === 'string'
        ? this.stylingGoals
        : this.stylingGoals.join(',');
    const profileId = v4();
    const siliconeFreeCheckbox = this.shadowRoot.querySelector(
      '#siliconeFreeCheckbox'
    );

    const siliconeFreeIsChecked = siliconeFreeCheckbox
      ? siliconeFreeCheckbox.checked
      : false;

    const regimenObject = {
      __product_handle: this.productHandle,
      __profile_id: profileId,
      __profile_name: `of ${this.name}`,
      __profile_type: this.productType,
      __fragrance: this.fragrance,
      __fragrance_strength: 'light',
      __hair_type: this.hairType,
      __hair_structure: this.hairThickness,
      __scalp_moisture: this.scalpType,
      __silicone_free: siliconeFreeIsChecked ? 1 : 0,
      __hair_goals: hairGoals,
      __shoppable: 'true',
      ...(this.fromRecommendation && { __from_recommendation: 'true' }),
      __body_moisture: this.bodyMoisture,
      ...(this.holdStrength && { __hold_strength: this.holdStrength }),
      ...(stylingGoals && { __style_goals: stylingGoals }),
      ...(this.isSos && {
        __damage_level: this.damage,
        __mechanical_damage_level: this.damage,
        __chemical_damage_level: this.damage,
        __heat_damage_level: this.damage
      })
    };

    this.quizContext?.saveRegimenProfile(regimenObject);

    return regimenObject;
  }

  handleChildEvent() {
    if (this.forceAddToCart) {
      this.buttonComponent.removeAttribute('disabled');
      return;
    }

    const buttonElements = Array.from(
      this.shadowRoot.querySelectorAll('buttons-layout')
    );
    const values = buttonElements.map((el) => el.selectedValue);

    this.buttonComponent.setAttribute('disabled', 'true');

    const isQuizAnswered = [
      ...values,
      this.name,
      ...(this.isSos ? [this.damage] : [])
    ].every((x) => {
      if (Array.isArray(x)) return x?.length > 0;
      if (typeof x === 'string') return x.length > 0;
      return !!x;
    });

    this.setHairGoalsError(!(this?.hairGoals?.length > 0));
    this.setStylingGoalsError(!(this?.stylingGoals?.length > 0));
    this.setNameError(this?.name?.length <= 0);

    if (isQuizAnswered) {
      this.buttonComponent.removeAttribute('disabled');
      this.setHairGoalsError(false);
      this.setNameError(false);
    } else {
      buttonElements.forEach((element) => {
        if (element.selectedValue.length > 0) {
          element.hideErrorMessage();
          return;
        }
        element.showErrorMessage();
        this.buttonComponent.setAttribute('disabled', 'true');
      });
      if (
        !this.name?.length <= 0 &&
        (!this.hairGoals?.length <= 0 || !this.hairGoalsComponent) &&
        (!this.stylingGoals?.length <= 0 || !this.stylingGoalsComponent)
      ) {
        this.buttonComponent.removeAttribute('disabled');
      }
    }
    return;
  }

  setHairGoalsError(value) {
    this?.hairGoalsComponent?.shadowRoot
      ?.querySelector('.error-message')
      ?.classList.toggle('show', value);
  }

  setStylingGoalsError(value) {
    this?.stylingGoalsComponent?.shadowRoot
      ?.querySelector('.error-message')
      ?.classList.toggle('show', value);
  }

  setNameError(value) {
    this.shadowRoot
      .querySelector('.error-name-message')
      .classList.toggle('show', value);
  }

  get variantId() {
    return this.getAttribute('variant-id');
  }

  get productHandle() {
    return this.getAttribute('product-handle');
  }

  get price() {
    return this.getAttribute('price');
  }

  get fragranceComponent() {
    const fragrancesSelector = this?.shadowRoot?.querySelector(
      '#fragrancesSelector'
    );
    if (fragrancesSelector) {
      return fragrancesSelector;
    }
    return this?.shadowRoot?.querySelector('#fragrancesSelectorButtons');
  }

  get hairTypeComponent() {
    const hairTypesSelector =
      this?.shadowRoot?.querySelector('#hairTypesSelector');
    if (hairTypesSelector) {
      return hairTypesSelector;
    }
    return this?.shadowRoot?.querySelector('#hairTypesSelectorButtons');
  }

  get hairGoalsComponent() {
    return this?.shadowRoot?.querySelector('#hairGoalsSelectorButtons');
  }

  get scalpTypeComponent() {
    const hairScalpType = this?.shadowRoot?.querySelector('#scalpTypeSelector');
    if (hairScalpType) {
      return hairScalpType;
    }
    return this?.shadowRoot?.querySelector('#scalpTypeSelectorButtons');
  }

  get hairThicknessComponent() {
    const hairThicknessSelector = this?.shadowRoot?.querySelector(
      '#hairThicknessSelector'
    );
    if (hairThicknessSelector) {
      return hairThicknessSelector;
    }
    return this?.shadowRoot?.querySelector('#hairThicknessSelectorButtons');
  }

  get stylingGoalsComponent() {
    const stylingGoalsSelector = this?.shadowRoot?.querySelector(
      '#stylingGoalsSelector'
    );
    if (stylingGoalsSelector) {
      return stylingGoalsSelector;
    }
    return this?.shadowRoot?.querySelector('#stylingGoalsSelectorButtons');
  }

  get holdStrengthComponent() {
    const holdStrengthSelector = this?.shadowRoot?.querySelector(
      '#holdStrengthSelector'
    );
    if (holdStrengthSelector) {
      return holdStrengthSelector;
    }
    return this?.shadowRoot?.querySelector('#holdStrengthSelectorButtons');
  }

  get buttonComponent() {
    return this?.shadowRoot?.querySelector('#addToCartButton');
  }

  get hairType() {
    const isButtonsLayout =
      this?.hairTypeComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#hairTypesSelectorButtons')
          ?.getAttribute('value') ?? '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return objectValue[0];
      } else {
        return '';
      }
    }
    return (
      this?.hairTypeComponent?.shadowRoot
        .querySelector('li.selected')
        .getAttribute('value') ??
      this.data.defaultValuesMiniQuiz.value.hairTypeDefault
    );
  }

  get bodyMoisture() {
    return this.shadowRoot.querySelector('#bodyMoistureSelectorButtons')
      ?.selectedValue?.[0];
  }

  get excludedProductColorsVariantsFromMiniQuiz() {
    return this.data.excludedProductColorsVariantsFromMiniQuiz?.value ?? [];
  }

  get fragrance() {
    const isButtonsLayout =
      this?.fragranceComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#fragrancesSelectorButtons')
          ?.getAttribute('value') || '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return objectValue[0];
      } else {
        return '';
      }
    }
    return (
      this?.fragranceComponent?.shadowRoot
        .querySelector('li.selected')
        .getAttribute('value') ??
      this.data.defaultValuesMiniQuiz.value.fragranceDefault
    );
  }
  get hairThickness() {
    const isButtonsLayout =
      this?.hairThicknessComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#hairThicknessSelectorButtons')
          ?.getAttribute('value') ?? '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return objectValue[0];
      } else {
        return '';
      }
    }
    return (
      this?.hairThicknessComponent?.selectedValue ??
      this.data.defaultValuesMiniQuiz.value.hairThicknessDefault
    );
  }

  get stylingGoals() {
    const isButtonsLayout =
      this?.stylingGoalsComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#stylingGoalsSelectorButtons')
          ?.getAttribute('value') ?? '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return objectValue;
      } else {
        return '';
      }
    }
    return (
      this?.stylingGoalsComponent?.selectedValue ??
      (Array.isArray(this.data.defaultValuesMiniQuiz.value.stylingGoalDefault)
        ? this.data.defaultValuesMiniQuiz.value.stylingGoalDefault.join(',')
        : this.data.defaultValuesMiniQuiz.value.stylingGoalDefault)
    );
  }

  get holdStrength() {
    const isButtonsLayout =
      this?.holdStrengthComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#holdStrengthSelectorButtons')
          ?.getAttribute('value') ?? '[]';

      const objectValue = JSON.parse(stringValue);
      return objectValue;
    }
    return (
      this?.holdStrengthComponent?.selectedValue ??
      this.data.defaultValuesMiniQuiz.value.holdStrengthDefault
    );
  }

  get scalpType() {
    const isButtonsLayout =
      this?.scalpTypeComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#scalpTypeSelectorButtons')
          ?.getAttribute('value') ?? '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return objectValue[0];
      } else {
        return '';
      }
    }
    return (
      this?.scalpTypeComponent?.selectedValue ??
      this.data.defaultValuesMiniQuiz.value.scalpTypeDefault
    );
  }

  get hairGoals() {
    const component = this?.shadowRoot?.querySelector(
      '#hairGoalsSelectorButtons'
    );
    const value = component?.getAttribute('value');

    if (!value) {
      const defaultValues =
        this.data.defaultValuesMiniQuiz.value.hairGoalsDefault;

      return defaultValues;
    }

    const stringValue = value ?? '[]';
    const objectValue = JSON.parse(stringValue);

    return objectValue;
  }

  get colorSelector() {
    return (
      this?.shadowRoot?.querySelector('color-selection') || {
        onSelected: () => {}
      }
    );
  }

  get nameComponent() {
    return this?.shadowRoot?.querySelector('#nameInput');
  }

  get damageComponent() {
    const damageSelector = this?.shadowRoot?.querySelector('#damageSelector');
    if (damageSelector) {
      return damageSelector;
    }
    return this?.shadowRoot?.querySelector('#damageSelectorButtons');
  }

  get damage() {
    const isButtonsLayout =
      this?.damageComponent?.id?.includes('SelectorButtons');
    if (isButtonsLayout) {
      const stringValue =
        this?.shadowRoot
          ?.querySelector('#damageSelectorButtons')
          ?.getAttribute('value') ?? '';

      if (stringValue) {
        const objectValue = JSON.parse(stringValue);
        return Number(objectValue[0]);
      } else {
        return '';
      }
    }

    const value =
      this?.damageComponent?.selectedValue ??
      this.data.defaultValuesMiniQuiz.value.damageDefault;

    return parseInt(value, 10);
  }

  get isSos() {
    return (
      this?.productHandle?.toLowerCase()?.includes('sos') ||
      this.quizType == 'bundle'
    );
  }

  get productsColorBundle() {
    return this.data.productsColorBundle?.value ?? [];
  }

  get quizType() {
    return this.getAttribute('quiz-type');
  }

  get collectionTitle() {
    return this.getAttribute('data-collection-title');
  }

  get productType() {
    const productType =
      this.data?.products?.value?.[0]?.productType || 'Haircare';
    const typeMap = {
      Haircare: 'hair',
      Bodycare: 'body'
    };
    return typeMap[productType] || 'skin';
  }

  get excludedGoals() {
    return this.getAttribute('excluded-goals') || '';
  }

  get excludedColors() {
    return this.getAttribute('excluded-colors') || '';
  }

  get shortFragranceList() {
    return this.getAttribute('short-fragrance-list') === '';
  }

  get showQuantityInput() {
    return this.getAttribute('show-quantity-input') === '';
  }

  get afterAddToCartAction() {
    return this.getAttribute('after-add-to-cart-action');
  }

  get bundleIsRetail() {
    return this.getAttribute('bundle-is-retail') === 'true';
  }

  get redirectToCheckout() {
    return this.afterAddToCartAction === ACTIONS.REDIRECT_TO_CHECKOUT;
  }

  get ctaUrl() {
    return this.redirectToCheckout ? 'checkout' : 'cart';
  }

  get ctaText() {
    return this.buttonComponent
      .querySelector('.add-to-cart-text')
      .innerText.toLowerCase();
  }

  get showProfileName() {
    return this.getAttribute('show-profile-name') === null ||
      this.getAttribute('show-profile-name') === 'true'
      ? true
      : false;
  }

  get showCustomizations() {
    return this.getAttribute('show-customizations') === null ||
      this.getAttribute('show-customizations') === 'true'
      ? true
      : false;
  }

  get forceAddToCart() {
    return this.getAttribute('force-add-to-cart') === 'true';
  }

  set ctaText(value) {
    this.buttonComponent.querySelector('.add-to-cart-text').innerText = value;
  }

  get fromRecommendation() {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source');
    return source === 'recommendation';
  }

  get fragrances() {
    const fragrancesMetafield = this.data.fragrances;
    if (!fragrancesMetafield) {
      const fragranceList = this.shortFragranceList
        ? fragranceMap.filter((item) => !item.coreOnly)
        : fragranceMap;

      return fragranceList.map((fragrance) => {
        return {
          text: fragrance.name,
          value: fragrance.dataKey,
          description: fragrance.description,
          imgUrl: fragrance.imageSecondary || fragrance.image,
          isDefault: fragrance.dataKey == DEFAULT_FRAGRANCE
        };
      });
    } else {
      const fragranceList = this.data.fragrances.value;
      return fragranceList.map((fragrance) => {
        return {
          text: fragrance.name,
          value: fragrance.dataKey,
          description: fragrance.description,
          imgUrl: fragrance.imageSecondary || fragrance.image,
          isDefault: fragrance.dataKey == DEFAULT_FRAGRANCE
        };
      });
    }
  }

  setQuantity = (value) => {
    this.quantity = value;
    value = Math.max(value, 1);
    this.data.products.value.map(
      (product) => (product.quantity = product.initial_quantity * value)
    );
  };

  setCtaToDefault = () => {
    this.ctaText = this.redirectToCheckout
      ? 'Proceed to Checkout'
      : 'Add to cart';
  };
}
